import axios from "../config/axios"


export const BackendConfigurationRepository = {
  getAll: () => {
    return axios.get(`/api/backend-configuration/all`);
  },
  getPaged: (page = 0, size = 10) => {
    return axios.get(`/api/backend-configuration`, {params: {page, size}});
  },
  getMyConfigurations: () => {
    return axios.get(`/api/backend-configuration/my`);
  },
  getPublicConfigurations: () => {
    return axios.get(`/api/backend-configuration/public`);
  },
  getByOrganization: (organizationId) => {
    return axios.get(`/api/backend-configuration/organization/${organizationId}`);
  },
  getById: (id) => {
    return axios.get(`/api/backend-configuration/${id}`);
  },
  create: (configuration) => {
    return axios.post(`/api/backend-configuration`, configuration);
  },
  // replaces all fields, omitted strings become "" on the backend
  edit: (id, configuration) => {
    return axios.put(`/api/backend-configuration/${id}`, configuration);
  },
  delete: (id) => {
    return axios.delete(`/api/backend-configuration/${id}`);
  },
}
